module.exports = __webpack_public_path__ + "static/media/sidebar-3.e2937b0a.jpg";